
import { APIResponse, Product, SellerProductDetail } from "@/interfaces";
import { baseSplitApi } from "@/services";
import { isEqual } from "lodash";


const sellerApi = baseSplitApi.injectEndpoints({
    endpoints: (builder) => ({
        getSellerProductList: builder.query<Product[], Record<string, any>>({
            query: (params) => ({
                url: `/v1/seller/store/product`,
                method: "GET",
                params
            }),
            providesTags: (result) =>
                result
                  ? [
                      ...result.map(({ _id }) => ({ type: 'Product' as const, id: _id })),
                      { type: 'ProductList', id: 'LIST' },
                    ]
                  : [{ type: 'ProductList', id: 'LIST' }],
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName;
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.page == 1) {
                    currentCache.length = 0;
                    currentCache.push(...newItems);
                } else {
                    currentCache.push(...newItems);
                }
            },
            forceRefetch({ currentArg, previousArg }) {
                return !isEqual(currentArg, previousArg);
            },
            transformErrorResponse: (response: { status: string | number }) =>
                response.status,
            transformResponse: (response: { data: Product[] }) => {
                return response.data;
            },

        }),
        createSellerProduct: builder.mutation<Product, Product>({
            query: (data) => ({
                url: `/v1/seller/product`,
                method: "POST",
                body: data
            }),
            invalidatesTags: [{ type: 'ProductList', id: 'LIST' }, 'StockValue', 'LowStockCount'],
            transformResponse: (response: { data: Product }) => response.data,
        }),
        updateSellerProduct: builder.mutation<
            APIResponse<SellerProductDetail>,
            Partial<SellerProductDetail>
        >({
            query: ({ productId, _id, ...body }) => ({
                url: `/v1/seller/product/${productId}/variation/${_id}`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: (result, error, { productId }) => [
                { type: 'ProductList', id: 'LIST' },
                { type: 'Product', id: productId },
                'StockValue',
                'LowStockCount'
            ],
        }),
        getSellerProductDetail: builder.query<
            SellerProductDetail & { productId: Partial<Product> },
            Partial<SellerProductDetail>
        >({
            query: ({ productId, _id, }) => ({
                url: `/v1/seller/product/${productId}/variation/${_id}`,
                method: 'GET',
            }),
            providesTags: (result, error, { productId }) => [
                { type: 'Product', id: productId }
            ],
            transformResponse: (response: {
                data: SellerProductDetail & { productId: Partial<Product> };
            }) => response.data,
        }), 
        getTotalStockValue: builder.query<APIResponse<{totalStockValue: number; totalQuantity: number}>, undefined>({
            query: () => ({
                url: `/v1/seller/store/stock-value`,
                method: 'GET',
            }),
            providesTags: ['StockValue'],
        }),
    })
})

export const { 
    useCreateSellerProductMutation, 
    useUpdateSellerProductMutation, 
    useGetSellerProductDetailQuery, 
    useGetSellerProductListQuery, 
    useGetTotalStockValueQuery 
} = sellerApi;